import axios from 'axios';
import powerBISettings from '../configs/powerBISettings.js';

const reportServiceUrl = powerBISettings.reportServiceUrl;
const tenantAdminServiceUrl = powerBISettings.tenantAdminServiceUrl;

export function getReportNotificationListByUser(tenantId, userId) {
  return axios.get(`${reportServiceUrl}reportnotification/ByUser/tenant/${tenantId}/user/${userId}`);
}

export function getReportNotificationListOfCurrentUser() {
  return axios.get(`${reportServiceUrl}reportnotification`);
}

export function addReportNotification(reportNotification) {
  return axios.post(`${reportServiceUrl}reportnotification`, reportNotification);
}

export function updateReportNotification(reportNotification) {
  return axios.post(`${reportServiceUrl}reportnotification/UpdateReportNotification`, reportNotification);
}

export function deleteReportNotification(tenantId, subscriptionId, featureId) {
  return axios.delete(`${reportServiceUrl}reportnotification/tenant/${tenantId}/subscriptionId/${subscriptionId}/feature/${featureId}`);
}

export function getExternalUserEmailListForTenant(tenantId) {
  return axios.get(`${reportServiceUrl}reportnotification/externaluseremail/${tenantId}`);
}

export function addExternalUserEmailList(externalUserList) {
  return axios.post(`${reportServiceUrl}reportnotification/externaluseremail`, externalUserList);
}

export function runReportNotificationService() {
  return axios.get(`${reportServiceUrl}reportnotification/runreportnotification`);
}

export function getReportNotificationsIAmMemberOf(tenantId, userId) {
  return axios.get(`${reportServiceUrl}reportnotification/ByUserSubscribed/tenant/${tenantId}/user/${userId}`);
}

export function getTenantEmailBodyTemplates(tenantId) {
  return axios.get(`${reportServiceUrl}reportnotification/EmailBodyTemplates/tenant/${tenantId}`);
}

export function getTenantAllConfigs(tenantId) {
  return axios.get(`${tenantAdminServiceUrl}config/tenantId/${tenantId}`);
}

export function subscribeReportNotification(reportNotification) {
  return axios.post(`${reportServiceUrl}reportnotification/Subscribe`, reportNotification);
}

export function unsubscribeReportNotification(reportNotification) {
  return axios.post(`${reportServiceUrl}reportnotification/Unsubscribe`, reportNotification);
}

export function getContentPackReportPagesList(objectId, tenantId) {
  return axios.get(`${reportServiceUrl}reportnotification/ContentPackReportPages/tenant/${tenantId}/object/${objectId}`);
}

export function updatePropertiesReportNotification(reportNotification) {
  return axios.post(`${reportServiceUrl}reportnotification/ReportNotificationProperties`, reportNotification);
}

export function getHVAobjectFilters(objectId, includeFullHierarchy) {
  return axios.get(`${tenantAdminServiceUrl}HVAObjectFilter/All/objectId/${objectId}/includeFullHierarchy/${includeFullHierarchy}`);
}

export function deleteReportNotificationObjectFilter(hvaObjectFilterId, subscriptionId) {
  return axios.delete(`${reportServiceUrl}reportnotification/DeleteReportNotificationObjectFilter/hvaObjectFilterId/${hvaObjectFilterId}/subscriptionId/${subscriptionId}`);
}

export function updateReportNotificationObjectFilters(reportNotificationObjectFilters) {
  return axios.post(`${reportServiceUrl}reportnotification/UpdateReportNotificationObjectFilters`, reportNotificationObjectFilters);
}

export function getAllReportNotificationObjectFiltersList(subscriptionId) {
  return axios.get(`${reportServiceUrl}reportnotification/GetAllReportNotificationObjectFilters/subscriptionId/${subscriptionId}`);
}

export function getErrorMessage(error) {
  let errorMessage = '';
  if (error.status === 409) {
    return errorMessage;
  }
  if (error.response && error.response.data && error.response.data.Message) {
    errorMessage = error.response.data.Message;
  } else if (error.response && error.response.data) {
    errorMessage = error.response.data;
  } else if (error.response && error.response.status !== -1) {
    errorMessage = error.response.status + ' - ' + error.response.statusText;
  } else {
    errorMessage = 'Unknown error';
  }
  return errorMessage;
}